import { useCallback, useMemo, useState } from 'react'
import constants from 'app/constants'
import fetchJSONData from 'app/util/fetchJSONData'

/**
 * The `useLoaders`
 *
 * @returns {object} the loaders information
 */
function useLoaders () {
  const [appData, setAppData] = useState(null)

  /**
   * Load the app data
   */
  const loadAppData = useCallback(async () => {
    try {
      const response = await fetchJSONData(
        `${constants.PATH_DATA}/app.json?ver=${constants.CACHE_BUST_VERSION}`
      )

      if (!response.success) {
        throw new Error('Failed to fetch application data')
      }

      setAppData(response.data)
    } catch (error) {
      console.error('Failed to load application data:', error)
    }
  }, [])

  /**
   * Loads the application
   */
  const loadApplication = useCallback(async () => {
    await loadAppData()
  }, [])

  /**
   * Memo: The context
   */
  const ctx = useMemo(
    () => ({
      loadApplication,
      appData
    }),
    [appData]
  )

  return ctx
}

export default useLoaders
